import { Button, Flex, Spinner } from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import BasicLayout from "../components/Layouts/BasicLayout";
import { getSingleMainOrder } from "../store/actions/mainOrder/mainOrder.action";
import { ComponentToPrint } from "./ComponentToPrint";

export const Example = () => {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);

  const dispatch = useDispatch();
  const [isError, setIsError] = useState(false);
  const history = useHistory();

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const mainorder = useSelector((state) => state.mainorder.mainorder);

  useEffect(() => {
    dispatch(getSingleMainOrder(id))
      .then((resp) => {
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setIsError(true);
      });
  }, [dispatch, id, history]);

  if (isError) {
    return <h1>Error</h1>;
  }

  if (isLoading) {
    return (
      <Flex h="100vh" w="100vw" justify="center" align="center">
        <Spinner />
      </Flex>
    );
  }
  return (
    <BasicLayout>
      <Flex minHeight="70vh" direction="column">
        <ComponentToPrint
          ref={componentRef}
          mainorder={mainorder}
          pageStyle={{ border: "2px solid red" }}
        />
        <Flex m="10">
          <Button
            w="200px"
            margin="auto"
            colorScheme="facebook"
            fontSize="20px"
            onClick={handlePrint}
          >
            प्रिंट करा !
          </Button>
          <Button
            w="200px"
            margin="auto"
            colorScheme="facebook"
            fontSize="20px"
          >
            <a href={`sms:${mainorder?.customer?.phonenumber}`}>मेसज पाटवा</a>
          </Button>
        </Flex>
      </Flex>
    </BasicLayout>
  );
};
